import {Component, OnInit} from '@angular/core';
import {DocumentService} from '../../services/document.service';
import {Document, DocumentId} from '../../models/document.modal';
import {DocHelper} from '../../services/document.helper';
import {Router} from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-doc-broker-appointment-letter',
    templateUrl: './doc-broker-appointment-letter.component.html',
    styleUrls: ['./doc-broker-appointment-letter.component.scss'],
    standalone: false
})
export class DocBrokerAppointmentLetterComponent implements OnInit {

  docDetails: Document[] = [];
  arrDistinctList: string[] = [];
  DocumentId = DocumentId;
  printDoc = false;

  constructor(
    private documentService: DocumentService,
    public router: Router,
  ) {
    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.printDoc = this.router.getCurrentNavigation()?.extras?.state?.print;
    }
  }

  ngOnInit(): void {
    this.documentService.getIP()
      .subscribe(res => {
      this.documentService.getDocument(DocumentId.BrokerAppointment, res?.ip)
        .subscribe((doc: Document[]) => {
          const dList = {};
          this.arrDistinctList = [];
          if (doc?.length) {
            this.docDetails = doc.sort((a, b) => a.index - b.index);

            this.docDetails.forEach(list => {
              if (!dList[list?.section_name] && list?.section_name.toLowerCase() !== 'header') {
                dList[list?.section_name] = true;
                this.arrDistinctList.push(list?.section_name);
              }
            });
            $([document.documentElement, document.body]).animate({
              scrollTop: $('.page').offset().top
            }, 0);
            setTimeout(() => {
              if (this.printDoc) {
                window.print();
              }
            }, 1000);

          }

        });
    });
  }

  getDocumentSection(sectionName = ''): any[] {
    return DocHelper.getDocumentSection(this.docDetails, sectionName);
  }
}
